



























import { Vue, Component, Prop } from "vue-property-decorator";
import type { ICustomStylingClass, TabType } from "@/components/Globals/types/custom.t";
import CustomText from "@/components/Globals/CustomText.vue";
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import TabUpcharge from '@/components/Globals/atom.tabUpcharge.vue';
import TabIcon from '@/components/Globals/atom.tabIcon.vue';
import TabTooltip from '@/components/Globals/atom.tabTooltip.vue';
import Tabs from "@/mixins/Tabs";

@Component({
  components: {
    CustomText,
    CustomContainer,
    TabUpcharge,
    TabIcon,
    TabTooltip
  },
  mixins: [Tabs],
})
export default class SwatchTab extends Vue {
  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  tab!: TabType;

  get activeTab() {
    return this.$store.state.swatchTray.activeTab;
  }

  get swatchesCount() {
    if(!this.tab.sub_groups) return 0;
    return this.$store.getters["swatchTray/returnTotalSwatchesPerComponent"]({ tabSubgroup: this.tab.sub_groups, activeComponent: (this as any).activeComponent });
  }

  created() {
    if (this.$store.state.utils.isDesignTransfering) {
      this.$store.commit('swatches/CLEAR_STATE_IN_TRANSFERING_DESIGN');
      this.$eventBus.$emit("blockRelationSwatches");
      (this as any).loadedComponentSelectedTab();
      (this as any).setHistoryTab();
      (this as any).initGroup = 4;
    }
    this.$eventBus.$on("selectedTab", (this as any).loadedComponentSelectedTab);
    this.$eventBus.$on("disable-ugc-tab", (this as any).blockUGCTab);
    this.$eventBus.$on("changeTab", (this as any).changeTab);
    this.$eventBus.$on('block-features-by-swatch-id', (this as any).disablePersonalizationTab);
    this.$eventBus.$on('block-features-by-precreated-recipe', (this as any).blockFeaturesByRecipeID);
    this.$eventBus.$on('select-previous-tab', (this as any).selectPreviousTab);
  }

   beforeDestroy() {
    this.$eventBus.$off("selectedTab", (this as any).loadedComponentSelectedTab);
    this.$eventBus.$off("disable-ugc-tab", (this as any).blockUGCTab);
    this.$eventBus.$off("changeTab", (this as any).changeTab);
    this.$eventBus.$off('block-features-by-swatch-id', (this as any).disablePersonalizationTab);
    this.$eventBus.$off('block-features-by-precreated-recipe', (this as any).blockFeaturesByRecipeID);
    this.$eventBus.$off('select-previous-tab', (this as any).selectPreviousTab);
  }
}
